import * as React from 'react';
import {Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {SaveUserRequest, User} from '../api/dtos/dtos';
import locales from '../locales';
import InputFormItem from '../common/form-items/InputFormItem';
import SubmitCancelFormItem from '../common/form-items/SubmitCancelFormItem';
import CheckBoxFormItem from "../common/form-items/CheckBoxFormItem";
import SelectFormItem from "../common/form-items/SelectFormItem";
import {getUserRoleOptions} from "./dto";
import PasswordFormItem from "../common/form-items/PasswordFormItem";


interface UserFormProps extends FormComponentProps {
  user: User;
  passwordMandatory: boolean
  onFormSubmit?: (userRequest: SaveUserRequest) => void;
  onFormCancel: () => void;
}

const FIELD_NAME = 'userName';
const FIELD_PASSWORD = 'password';
const FIELD_ROLE = 'role';
const FIELD_ENABLED = 'enabled';

class UserForm extends React.Component<UserFormProps, {}> {


  public render() {
    const {form, user, passwordMandatory} = this.props;
    return (
      <Form>
        <InputFormItem
          form={form}
          fieldId={FIELD_NAME}
          label={locales.username}
          initialValue={user.userName}
          required={true}
          disabled={user.userName !== undefined}
        />

        <PasswordFormItem
          form={form}
          fieldId={FIELD_PASSWORD}
          initialValue={undefined}
          required={passwordMandatory}
          rules={[
            {
              validator: this.validateWhitespace
            }
          ]}
        />

        <SelectFormItem
          form={form}
          fieldId={FIELD_ROLE}
          label={locales.user_role}
          initialValue={user.role}
          required={true}
          options={getUserRoleOptions()}
        />

        <CheckBoxFormItem
          form={form}
          fieldId={FIELD_ENABLED}
          label={locales.user_enabled}
          initialValue={user.enabled}
          required={false}
        />
        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private validateWhitespace = (_: any, value: any, callback: any) => {
    const regex = /\s/;
    !(regex.test(value))
      ? callback()
      : callback(locales.error_whitespace)
  }


  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {form, user, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit?.({
          ...user,
          userName: values[FIELD_NAME],
          password: values[FIELD_PASSWORD],
          role: values[FIELD_ROLE],
          enabled: values[FIELD_ENABLED],
        });
      }
    });
  };
}

export default Form.create<UserFormProps>()(UserForm);



// WEBPACK FOOTER //
// ./src/user-management/UserForm.tsx